import { atom } from "jotai";

import { DiningBookingWizard } from "../types";

export const DiningBookingWizardDataAtom =
  atom<DiningBookingWizard.DiningBookingWizardData | null>(null);

export const DiningBookingWizardCurrentStepAtom =
  atom<DiningBookingWizard.DiningBookingWizardStep | null>(null);

export const DiningBookingWizardListOfStepsAtom = atom<
  DiningBookingWizard.DiningBookingWizardStep[]
>([]);

export const DiningBookingKnownPeopleAtom = atom<
  DiningBookingWizard.DiningBookingKnownPerson[]
>([]);
export const DiningBookingOwnerMemberAtom =
  atom<DiningBookingWizard.DiningBookingKnownPerson | null>(null);
